import script from "./ProfileScreen.vue?vue&type=script&setup=true&lang=js"
export * from "./ProfileScreen.vue?vue&type=script&setup=true&lang=js"

import "./ProfileScreen.vue?vue&type=style&index=0&id=1b59b8f3&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1b59b8f3"]])

export default __exports__